'use es6';

export const throwErrorAsync = error => {
  setTimeout(() => {
    throw error;
  }, 0);
};